import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    userId: localStorage.getItem('userId') || '',
    role: localStorage.getItem('role') || '',
    username: localStorage.getItem('username') || '',
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    isAdmin: (state) => ['reviewer', 'superadmin'].includes(state.role),
    isSuperadmin: (state) => state.role === 'superadmin',
    isReviewer: (state) => state.role === 'reviewer',
    isWorker: (state) => state.role === 'worker',
    token: (state) => state.token,
    userId: (state) => state.userId,
    role: (state) => state.role,
    username: (state) => state.username,
  },
  mutations: {
    SET_USER(state, { token, userId, role, username }) {
      state.token = token
      state.userId = userId
      state.role = role
      state.username = username
      localStorage.setItem('token', token)
      localStorage.setItem('userId', userId)
      localStorage.setItem('role', role)
      localStorage.setItem('username', username)
    },
    CLEAR_USER(state) {
      state.token = ''
      state.userId = ''
      state.role = ''
      state.username = ''
      localStorage.removeItem('token')
      localStorage.removeItem('userId')
      localStorage.removeItem('role')
      localStorage.removeItem('username')
    },
  },
  actions: {
    login({ commit }, userData) {
      commit('SET_USER', userData)
    },
    logout({ commit }) {
      commit('CLEAR_USER')
    },
  },
})
